var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.userGuide
    ? _c("div", { staticClass: "main-content userGuide-view-page" }, [
        _c("div", { staticClass: "page-header" }, [
          _c("h3", { staticClass: "page-title" }, [
            _vm._v(" " + _vm._s(_vm.userGuide.name)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "page-actions row" }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "userGuide-sidebar" },
          [
            _c(
              "div",
              { staticClass: "side-header" },
              [
                _c("base-input", {
                  attrs: {
                    placeholder: _vm.$t("general.search"),
                    "input-class": "userGu-search",
                    icon: "search",
                    type: "text",
                    "align-icon": "right",
                  },
                  on: { input: _vm.onSearch },
                  model: {
                    value: _vm.searchData.searchText,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchData, "searchText", $$v)
                    },
                    expression: "searchData.searchText",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn-group ml-3",
                    attrs: { role: "group", "aria-label": "First group" },
                  },
                  [
                    _c(
                      "base-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.top-center",
                            value: { content: _vm.getOrderName },
                            expression: "{ content: getOrderName }",
                            modifiers: { "top-center": true },
                          },
                        ],
                        staticClass: "userGu-button userGu-filter-sorting-btn",
                        attrs: { color: "default", size: "medium" },
                        on: { click: _vm.sortData },
                      },
                      [
                        _vm.getOrderBy
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "sort-amount-up" },
                            })
                          : _c("font-awesome-icon", {
                              attrs: { icon: "sort-amount-down" },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isSearching
              ? _c("base-loader")
              : _c(
                  "div",
                  { staticClass: "side-content" },
                  [
                    _vm._l(_vm.userGuides, function (userGuide, index) {
                      return _c(
                        "a",
                        {
                          key: index,
                          staticClass: "side-userGuide",
                          attrs: {
                            href: "#/",
                            to:
                              "/super-admin/user-guides/" +
                              userGuide.id +
                              "/view",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.viewUserGuideRoute(userGuide.id)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "left" }, [
                            _c("div", { staticClass: "userGu-name" }, [
                              _vm._v("Name: " + _vm._s(userGuide.name)),
                            ]),
                            _vm._v(" "),
                            _vm.userType == "super_admin"
                              ? _c("div", { staticClass: "userGu-number" }, [
                                  _vm._v("Type: " + _vm._s(userGuide.type)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userType == "super_admin"
                              ? _c("div", { staticClass: "userGu-number" }, [
                                  _vm._v("Status: " + _vm._s(userGuide.status)),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "right" }, [
                            _vm.userType == "super_admin"
                              ? _c("div", { staticClass: "userGu-date" }, [
                                  _vm._v(_vm._s(userGuide.formattedCreatedAt)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    !_vm.userGuides.length
                      ? _c("p", { staticClass: "no-result" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("user_guides.no_matching_user_guide")
                              ) +
                              "\n      "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "userGuide-view-page-container" }, [
          _c("iframe", {
            staticClass: "frame-style",
            attrs: { src: "" + _vm.shareableLink },
          }),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }